/// <reference types="vite-plugin-pwa/vue" />
import { useRegisterSW } from 'virtual:pwa-register/vue'

// De quanto em quanto tempo a aba pergunta ao servidor se há versão nova. O
// navegador só confere o service worker ao navegar, e o Whiz fica aberto o dia
// todo numa aba só — sem isto, a versão nova só seria vista no dia seguinte.
const INTERVALO_VERIFICACAO_MS = 30 * 60 * 1000

const { needRefresh, updateServiceWorker } = useRegisterSW({
  onRegisteredSW(swUrl, registration) {
    console.log('[PWA] Service worker registrado.')
    if (!registration) return
    setInterval(() => {
      if (!navigator.onLine) return
      registration.update().catch((e) => console.error('[registerServiceWorker] update', e))
    }, INTERVALO_VERIFICACAO_MS)
  },
  onOfflineReady() {
    console.log('[PWA] Conteúdo cacheado para uso offline.')
  },
  onNeedRefresh() {
    console.log('[PWA] Nova versão disponível.')
  },
})

/** Versão nova instalada e esperando: o aviso de atualização observa isto. */
export const novaVersaoDisponivel = needRefresh

/** Troca para a versão nova e recarrega a página (todas as abas do Whiz). */
export function atualizarParaNovaVersao(): Promise<void> {
  return updateServiceWorker(true)
}

// The updated + swUpdated event equivalent:
// vite-plugin-pwa doesn't expose an "updated" callback directly in useRegisterSW,
// so we replicate it by listening to the SW lifecycle manually:
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then((registration) => {
    registration.addEventListener('updatefound', () => {
      console.log('[PWA] Nova versão sendo baixada...')
      const newWorker = registration.installing
      newWorker?.addEventListener('statechange', () => {
        if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
          console.log('[PWA] Nova versão disponível.')
          // Same custom event your Vue components are already listening to
          document.dispatchEvent(new CustomEvent('swUpdated', { detail: registration }))
        }
      })
    })
  }).catch(e => console.error(`[registerServiceWorker]`, e))
}
